.vc-settings-tab-bar {
    margin-top: 20px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--border-subtle);
}

.vc-settings-tab-bar-item {
    margin-right: 32px;
    padding-bottom: 16px;
    margin-bottom: -2px;
}

.vc-settings-donate {
    display: flex;
    flex-direction: row;
}

.vc-settings-card {
    padding: 1em;
    margin-bottom: 1em;
}

.vc-warning-card {
    padding: 1em;
    background: var(--info-warning-background);
    border: 1px solid var(--info-warning-foreground);
    color: var(--info-warning-foreground);
}

.vc-backup-restore-card {
    background-color: var(--info-warning-background);
    border-color: var(--info-warning-foreground);
    color: var(--info-warning-foreground);
}

.vc-settings-theme-links {
    /* Needed to fix bad themes that hide certain textarea elements for whatever eldritch reason */
    display: inline-block !important;
    color: var(--text-default) !important;
    padding: 0.5em 1em;
    border: 1px solid var(--input-border);
    max-height: unset;
    background-color: transparent;
    box-sizing: border-box;
    resize: none;
    width: 100%;
    font-size: 1em;
    line-height: 2em;
    white-space: nowrap;
}

.vc-settings-theme-links::placeholder {
    color: var(--text-muted) !important;
}

.vc-settings-theme-links:focus {
    background-color: var(--background-base-lowest);
}

.vc-cloud-settings-sync-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1em;
}

.vc-cloud-erase-data-danger-btn {
    color: var(--white-500);
    background-color: var(--button-danger-background);
}

.vc-updater-modal {
    padding: 1.5em !important;
}

.vc-updater-modal-close-button {
    float: right;
}